import * as authentication from "../../common/actions/authentication";
import * as support from "../actions/support.js";

import Immutable from "seamless-immutable";

const defaultState = () => {
    return Immutable({
        isLoading: false,
        faq: [],
        message: {},
    });
};

/**
 * support reducer
 * @param {Object} state
 * @param {{type: string}} action
 * @return {*}
 */
export default function(state = defaultState(), action) {
    switch(action.type) {
    case support.SET_FAQ_RESULTS:
        return state.merge({
            faq: action.results
        });
    case support.FAQ_IS_LOADING:
        return state.merge({
            isLoading: true,
        });
    case support.FAQ_DONE_LOADING:
    case support.FAQ_FAILED_LOADING:
        return state.merge({
            isLoading: false,
        });
    case support.CHANGE_SUPPORT_MESSAGE:
        return state.merge({
            message: {
                ...action.change
            }
        }, {
            deep: true
        });
    case support.CLEAR_SUPPORT_MESSAGE:
        return state.merge({
            message: {}
        });
    case authentication.LOGGED_OUT:
        return defaultState();
    default:
        return state;
    }
}
